import type { PropsWithChildren } from 'react';
import React from 'react';

import RequestAnimationFrame from './RequestAnimationFrame';

interface OnWindowResizeProps extends PropsWithChildren {
  onResize: () => void;
}

export default class OnWindowResize extends React.Component<OnWindowResizeProps> {
  windowInnerWidth: number;

  constructor(props) {
    super(props);

    this.onResize = this.onResize.bind(this);

    this.windowInnerWidth = NaN;
  }

  onResize() {
    if (this.windowInnerWidth === window.innerWidth) {
      return;
    }

    this.windowInnerWidth = window.innerWidth;

    this.props.onResize();
  }

  render() {
    return (
      <RequestAnimationFrame onFrame={this.onResize}>{this.props.children}</RequestAnimationFrame>
    );
  }
}
